<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button></ion-back-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="goToContactUs()">
        <ion-icon name="information-circle"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{title}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [scrollY]="false">
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <div class="ion-text-center" hidden>
          <p>Version {{appVersion}} Build {{buildVersion}}</p>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div>
    <form [formGroup]="loginForm" (ngSubmit)="verifyLogin()">
      <h4 class="auth-label">Mobile Number</h4>
      <ngx-intl-tel-input
        [cssClass]="'auth-input'"
        class="auth-input-wrapper"
        [preferredCountries]="[CountryIso.Australia, CountryIso.NewZealand]"
        [selectedCountryISO]="CountryIso.Australia"
        [enableAutoCountrySelect]="true"
        [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
        [enablePlaceholder]="true"
        [searchCountryFlag]="true"
        [maxLength]="15"
        [phoneValidation]="true"
        name="phone"
        formControlName="phone"
        #phoneNumberInput
      >
      </ngx-intl-tel-input>
      <p class="form-error" style="padding-left: 1rem;" *ngIf="!loginForm.valid">{{ errorMessage }}</p>
    </form>
  </div>
</ion-content>
<ion-footer class="auth-footer">
  <ion-toolbar color="primary">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-button expand="block" [disabled]="!loginForm.valid" (click)="verifyLogin()" class="auth-button primary">Send me a code</ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>